import type * as lazyIndex from "./lazyIndex";
import { LazyImport, LazyModule } from "owa-bundling-light";

const lazyCloudAwareFetchModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CloudAwareFetch" */ "./lazyIndex"), { name: "CloudAwareFetch" });

export const lazyFetchCloudAwareOcpsPolicies: LazyImport<typeof lazyIndex.fetchCloudAwareOcpsPolicies, typeof lazyCloudAwareFetchModule> = new LazyImport(lazyCloudAwareFetchModule, m => m.fetchCloudAwareOcpsPolicies);
